import React, { useState, VFC } from 'react';
import { useDispatch } from 'react-redux';
import cn from 'classnames';

import { ButtonIconButton } from '@/components/common/Button/IconButton';
import { notificationError } from '@/redux/index';

type TButtonIconButtonProps = React.ComponentProps<typeof ButtonIconButton>;

export type TFileProps = {
  date: string;
  name: string;
  size: string;
  pdfDl: string;
};

type TProps = {
  upload: React.ChangeEventHandler<HTMLInputElement>;
  data?: TFileProps | null;
  type: 'resume' | 'career';
  clickDeleteConfirm?: TButtonIconButtonProps['onClick'];
  disabled?: boolean;
};

export const SectionUpload: VFC<TProps> = ({
  upload,
  data,
  type,
  clickDeleteConfirm,
  disabled = false,
}) => {
  // ====================================================================================================
  //
  // setState
  //
  // ====================================================================================================
  const dispatch = useDispatch();

  const error = () => {
    dispatch(
      notificationError('入力代行を依頼中のため書類をアップロードおよび削除することができません。')
    );
  };

  return (
    <>
      <div className="flex w-full justify-between items-center mt-8 sm:flex-wrap">
        <div className="mr-8 w-190 flex-none">
          {!disabled ? (
            <label>
              <div className="mr-8 min-w-full base-button">
                <p className="button size-s theme-secondary flex items-center cursor-pointer">
                  <span className="font-bold label">
                    {type === 'resume' ? '履歴書' : '職務経歴書'}をアップロード
                  </span>
                </p>
              </div>
              <input
                type="file"
                onChange={upload}
                accept=".jpeg,.jpg,.doc,.docx,.xlsx,.xls,.txt,.pdf,.pptx,.ppt"
                className="hidden"
                disabled={disabled}
              />
            </label>
          ) : (
            <label className="opacity-40" onClick={() => error()}>
              <div className="mr-8 min-w-full base-button">
                <p className="button size-s theme-secondary flex items-center cursor-pointer">
                  <span className="font-bold label">
                    {type === 'resume' ? '履歴書' : '職務経歴書'}をアップロード
                  </span>
                </p>
              </div>
            </label>
          )}
        </div>
        {data && (
          <div className="flex w-full lg:w-4/5 md:w-440 justify-between items-center min-w-0">
            <div className="flex mbx-typography--body_1 min-w-0 mr-16">
              <p className="flex-none mr-8">{data.date}</p>
              <p className="truncate min-w-0">{data.name}</p>
              <p className="flex-none">({data.size})</p>
            </div>
            <div className="flex items-center flex-none">
              <div className="mr-8">
                <a href={data.pdfDl}>
                  <ButtonIconButton hitArea="mini" size="default" iconName="Download" type="gray" />
                </a>
              </div>
              <div
                className={cn({
                  'opacity-40': disabled,
                })}
              >
                <ButtonIconButton
                  hitArea="mini"
                  size="default"
                  iconName="Clear"
                  type="gray"
                  disabled={disabled}
                  onClick={clickDeleteConfirm}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
